// ===========================================================================
// 使用中のログイン切れの通知
// ===========================================================================
// BFF（cms-client-admin の ApiProxy）はログイン切れを 401 の JSON（error.not_login）で返す。
// cms-axios がそれを見たらここで鳴らし、AuthProvider が聞いて再ログインの案内を出す。
//
// window のイベントにしておく（cms-axios は React の外にあり、context を参照できないため）。
// ⚠ 依存の無いモジュールにしておく（cms-axios から読むので循環させない）。

export const SESSION_EXPIRED_EVENT = 'cms:session-expired';

export function notifySessionExpired() {
  try {
    window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
  } catch (e) {
    // window が無い環境（SSR・一部のテスト）では何もしない
  }
}

/** @returns {Function} 購読の解除 */
export function onSessionExpired(handler) {
  window.addEventListener(SESSION_EXPIRED_EVENT, handler);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
}
